import React, { Component } from "react";
import { Link } from "react-router-dom";
import Extrinsics from "./Extrinsics/Extrinsics";
import Block from "./Block/Block";
import { connect } from "react-redux";
import commaNumber from "comma-number";
import { holdersCount } from "../../api/holder.js";

class Home extends Component {
  state = {
    highcharts: null,
    holder_count: null,
  };

  holdersCountAPICall = async () => {
    const response = await holdersCount();
    this.setState({
      ...this.state,
      holder_count: response.data["count"],
    });
  };

  componentDidMount() {
    this.holdersCountAPICall();
  }

  
  render() {
    console.log('tester ', this.props.extrinsics);
    const {
      signedExtrinsicsCount,
      transfersCount,
      totalIssuance,
      holdersCount,
      totalCirculation,
      lockedValue
    } = this.props;

    return (
      <React.Fragment>
        <main className="mb-5">
          <section className="mb-4" id="Statistics">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 mb-4 mb-lg-0">
                  <h5 className="mb-3">
                    <i className="fas fa-chart-bar" /> Chain Data
                  </h5>
                  <div className="WhiteBox rounded p-4">
                    <div className="row">
                      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 d-flex align-items-center mb-4">
                        <i className="fas fa-th-large Fsize_20 mr-3" />
                        <div className="TextBox">
                          Latest Blocks
                          <h5 className="pt-1">
                            {this.props.blocks.length > 0 &&
                              commaNumber(this.props.blocks[0].block_id)}
                          </h5>
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 d-flex align-items-center mb-4">
                        <i className="fas fa-calculator Fsize_20 mr-3" />
                        <div className="TextBox">
                          Signed Extrinsics
                          <h5 className="pt-1">
                            {commaNumber(signedExtrinsicsCount)}
                          </h5>
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 d-flex align-items-center mb-4">
                        <i className="fas fa-exchange-alt Fsize_20 mr-3" />
                        <div className="TextBox">
                          Transfers
                          <h5 className="pt-1">
                            {commaNumber(transfersCount)}
                          </h5>
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 d-flex align-items-center mb-4 mb-sm-0">
                        <i className="fas fa-user Fsize_20 mr-3" />
                        <div className="TextBox">
                          Holders
                          <h5 className="pt-1">{this.state.holder_count ? commaNumber(this.state.holder_count) : 'N/A'}</h5>
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 d-flex align-items-center mb-4 mb-sm-0">
                        <i className="fas fa-chart-pie Fsize_20 mr-3" />
                        <div className="TextBox">
                          Total Issuance
                          <h5 className="pt-1">{totalIssuance ? commaNumber(totalIssuance) : "N/A"}</h5>
                          {/* <h5 className="pt-1">{"N/A"}</h5> */}
                        </div>
                      </div>
                      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 d-flex align-items-center mb-4 mb-sm-0">
                        <i className="fas fa-coins Fsize_20 mr-3" />
                        <div className="TextBox">
                          Total Supply / Hard Cap
                          <h5 className="pt-1">9.9 Billion</h5>
                        </div>
                      </div>

                      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 d-flex align-items-center mb-4 mb-sm-0 mt-3">
                        <i className="fas fa-chart-pie Fsize_20 mr-3" />
                        <div className="TextBox">
                          Total Circulation
                          <h5 className="pt-1">{totalCirculation ? commaNumber(totalCirculation) : "N/A"}</h5>
                          {/* <h5 className="pt-1">{"N/A"}</h5> */}
                        </div>
                      </div>

                      <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 d-flex align-items-center mb-4 mb-sm-0 mt-3">
                        <i className="fas fa-chart-pie Fsize_20 mr-3" />
                        <div className="TextBox">
                          Staked / Locked NUC
                          <h5 className="pt-1">{lockedValue ? commaNumber(lockedValue) : "N/A"}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-lg-4">
                                    <h5 className="mb-3"><i className="fas fa-chart-bar" /> Network Stats</h5>
                                    <div className="WhiteBox px-3">
                                        <figure className="highcharts-figure">
                                            <div id="PieChart" />
                                        </figure>
                                    </div>
                                </div> */}
              </div>
            </div>
          </section>
          <section id="TableBlock">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 mb-4 mb-lg-0">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <h5 className="mb-0">
                      <i className="fas fa-th-large align-middle Fsize_20 mr-3" />{" "}
                      Latest Blocks
                    </h5>
                    <Link className="btn BtnDark py-1 px-4" to={"/blocks"}>
                      All
                    </Link>
                  </div>
                  <div className="WhiteBox py-3 px-4">
                    {this.props.blocks.map((block) => (
                      <Block key={block.block_id} {...block} />
                    ))}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <h5 className="mb-0">
                      <i className="fas fa-exchange-alt Fsize_20 mr-3" />{" "}
                      Transfers
                    </h5>
                    <Link className="btn BtnDark py-1 px-4" to={"/extrinsics"}>
                      All
                    </Link>
                  </div>
                  <div className="WhiteBox py-3 px-4">
                    {this.props.extrinsics.map((extrinsic) => (
                      <Extrinsics key={extrinsic.id} {...extrinsic} />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  blocks: state.Block.blocks,
  extrinsics: state.Extrinsics.extrinsics,
  signedExtrinsicsCount: state.Block.signedExtrinsicsCount,
  transfersCount: state.Block.transfersCount,
  totalIssuance: state.Block.totalIssuance,
  holdersCount: state.Block.holdersCount,
  totalCirculation: state.Block.totalCirculation,
  lockedValue: state.Block.lockedValue,
});

export default connect(mapStateToProps, {})(Home);
